import React from "react";
import {
  FooterContainer,
  FooterWrap,
  FooterLinksContainer,
  FooterLinksWrapper,
  FooterLinkItems,
  FooterLinkTitle,
  FooterLink,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
  WebsiteRights,
  SocialIcons,
  SocialIconLink,
  AnchorLink,
} from "./FooterStyles";
import { BsCodeSlash } from "react-icons/bs";
import { SiGithub } from "react-icons/si";
import { FaLinkedin, FaTwitterSquare, FaFacebookSquare } from "react-icons/fa";
import { VscLink } from "react-icons/vsc";
import { FiInstagram } from "react-icons/fi";
import { animateScroll as scroll } from "react-scroll";
import { AiOutlineHeart } from "react-icons/ai";

function Footer() {
  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <FooterContainer>
      <FooterWrap>
        <SocialMedia>
          <SocialMediaWrap>
            <SocialLogo to="/" onClick={toggleHome}>
              <BsCodeSlash fontSize="3rem" />
              Nobert.dev
            </SocialLogo>
            <WebsiteRights>
              Nobert Langat &copy; {new Date().getFullYear()} All rights
              resolved. <br /> Created with <AiOutlineHeart /> by{" "}
              <span>
                {" "}
                <AnchorLink target="_blank" href="https://github.com/NOBERT167">
                  {" "}
                  Nobert.Dev{" "}
                </AnchorLink>{" "}
              </span>
            </WebsiteRights>
            <SocialIcons>
              <SocialIconLink
                href="https://github.com/NOBERT167"
                target="_blank"
              >
                <SiGithub />
              </SocialIconLink>
              <SocialIconLink
                href="https://www.linkedin.com/mwlite/in/langat-kipkoech-nobert-ab44661ba"
                target="_blank"
              >
                <FaLinkedin />
              </SocialIconLink>
              <SocialIconLink
                href="https://twitter.com/Darkcode1999"
                target="_blank"
              >
                <FaTwitterSquare />
              </SocialIconLink>
              <SocialIconLink
                href="https://www.instagram.com/nobert.dev/"
                target="_blank"
              >
                <FiInstagram />
              </SocialIconLink>
              <SocialIconLink
                href="https://www.facebook.com/nobert.langat.12"
                target="_blank"
              >
                <FaFacebookSquare />
              </SocialIconLink>
              <SocialIconLink href="https://bio.link/nobertdev" target="_blank">
                <VscLink />
              </SocialIconLink>
            </SocialIcons>
          </SocialMediaWrap>
        </SocialMedia>
      </FooterWrap>
    </FooterContainer>
  );
}

export default Footer;
